import { ArpyRequirementDto } from "src/app/models/dto/arpy/arpyRequirementDto";
import { ArpyVehicleFunctionDto } from "src/app/models/dto/arpy/arpyVehicleFunctionDto";
import { ArpyVehicleSubFunctionDto } from "src/app/models/dto/arpy/arpyVehicleSubFunctionDto";
import { GraphQLArpyVehicleFunctionCatalogOutput } from "../models/output/graphql-arpy-vehicle-function-catalog-output";

export interface ArpyVehicleFunctionParseResult {
  vehicleFunctions: ArpyVehicleFunctionDto[];
  vehicleSubFunctions: ArpyVehicleSubFunctionDto[];
  requirements: ArpyRequirementDto[];
}

// Converts the server-parsed catalog into the shape ArpyApiService.getAllVehicleFunctions()
// returns.
export function convertGraphqlArpyVehicleFunctionCatalog(
  input: GraphQLArpyVehicleFunctionCatalogOutput
): ArpyVehicleFunctionParseResult & { sourceFileVersion: number } {
  return {
    vehicleFunctions: input.vehicleFunctions.map(vf => ({
      uid: vf.uid,
      name: vf.name,
      description: vf.description,
      asil: vf.asil,
      subFunctionUids: vf.subFunctionUids,
      requirementUids: vf.requirementUids,
    })),
    vehicleSubFunctions: input.vehicleSubFunctions.map(sf => ({
      uid: sf.uid,
      name: sf.name,
      nameIsDerived: sf.nameIsDerived,
      vehicleFunctionUid: sf.vehicleFunctionUid,
      description: sf.description,
      asil: sf.asil,
      requirementUids: sf.requirementUids,
    })),
    requirements: input.requirements.map(req => ({
      uid: req.uid,
      name: req.name,
      version: req.version,
      description: req.description,
      asil: req.asil,
      maturityLevel: req.maturityLevel,
      status: req.status,
      vehicleFunctionUid: req.vehicleFunctionUid,
      vehicleSubFunctionUid: req.vehicleSubFunctionUid,
    })),
    sourceFileVersion: input.sourceFileVersion,
  };
}
